import uiSlice from './slice';
import * as selectors from './selectors';
import * as actions from './actions';

export const UIActions = { ...actions, ...uiSlice.actions };
export const UIReducer = uiSlice.reducer;
export const UISelectors = selectors;
